// Mapping eines numerischen Fuzzy-Match-Scores auf eine CSS-Klasse (high/mid/low/none).
// Backend liefert Scores 0..100 (siehe AveOrga.Core.Services / FuzzySharp). Frontend nutzt
// die Klasse für Pill-/Badge-Farben in Registrations, Event-Add und EditPlayerScreen.
export function scoreClass(score) {
  if (typeof score !== 'number') return 'none';
  if (score >= 90) return 'high';
  if (score >= 75) return 'mid';
  return 'low';
}
